import ActionButtonsSection from "../ActionButtonsSection";
import ConnectionTestSection from "../ConnectionTestSection";
import ExpiredRoomMessage from "../ExpiredRoomMessage";
import TelehealthRoomNotReady from "../TelehealthRoomNotReady";
import moment from "moment";
import styles from "./InformationCard.module.css";
import { Box, Card, Chip, Divider, Typography } from "@mui/material";
import { TelehealthSessionResponse } from "../../../types/generated/models";
import { palette } from "@powerdiary/components-library/lib";

interface IProps {
    sessions: TelehealthSessionResponse[];
}

const InformationCard = ({ sessions }: IProps) => {
    if (!sessions || sessions.length === 0) {
        return <TelehealthRoomNotReady />;
    }

    return (
        <Card
            variant="elevation"
            raised={true}
            className={styles.informationCard}
            data-test-id="card_sessions_information"
        >
            {sessions.map((session, idx) => {
                const { isRoomExpired, startDate, supplierName, roomId } = session;
                const sessionKey = `${session.roomId}-${session.startDate}`;

                if (isRoomExpired) {
                    return <ExpiredRoomMessage key={sessionKey} />;
                }

                const m = moment(startDate);
                const formattedDate = m.format("DD MMM YY");
                const formattedTime = m.format("h:mm a");

                return (
                    <Box key={sessionKey} data-test-id="available_sessions">
                        {sessions.length > 1 && (
                            <Box className={styles.chipContainer}>
                                {idx === 0 && (
                                    <Chip
                                        color="success"
                                        label="Next"
                                        variant="filled"
                                        size="small"
                                        className={styles.chip}
                                        data-test-id="chip_next"
                                    />
                                )}
                                {idx > 0 && (
                                    <Chip
                                        color="warning"
                                        label="Later"
                                        variant="filled"
                                        size="small"
                                        className={styles.chip}
                                        data-test-id="chip_later"
                                    />
                                )}
                            </Box>
                        )}
                        <Box textAlign="center" marginBottom="20px" data-test-id="session_block">
                            <Typography variant="paragraphExtraLargeRegular" color={palette.neutral["700"]}>
                                Your appointment with{" "}
                            </Typography>
                            <Typography variant="paragraphExtraLargeBold" data-test-id="session_supplier_name">
                                {supplierName}{" "}
                            </Typography>
                            <Typography variant="paragraphExtraLargeRegular" color={palette.neutral["700"]}>
                                is booked for{" "}
                            </Typography>
                            <Typography variant="paragraphExtraLargeBold" data-test-id="session_date">
                                {formattedDate}{" "}
                            </Typography>
                            <Typography variant="paragraphExtraLargeRegular" color={palette.neutral["700"]}>
                                at{" "}
                            </Typography>
                            <Typography variant="paragraphExtraLargeBold" data-test-id="session_time">
                                {formattedTime}
                            </Typography>
                        </Box>

                        <Box display="flex" flexDirection="column" gap="32px">
                            <Box textAlign="center">
                                <ActionButtonsSection startDate={startDate} roomId={roomId} />
                            </Box>
                        </Box>

                        <Divider className={styles.divider} />
                    </Box>
                );
            })}

            <Box textAlign="center">
                <ConnectionTestSection />
            </Box>
        </Card>
    );
};

export default InformationCard;
